import React from 'react'
import { ServerConfig } from 'config'

import NonPaginatedList from '../../components/EntryListAndEdit/NonPaginatedList'


const TenantCashdrawers = () => {
  const non_editable_fields = [
    ["id", "id", ""],
    //["owner", "Owner", ""]
  ];

  const editable_fields = [
    ["name", "Name"],
    ["belt_id", "Machine-ID"],
  ];

  return (
    <>
      <NonPaginatedList
        list_get_url={`${ServerConfig.SERVER_URL}/admin/tenant_cashdrawers`}
        detail_get_url={`${ServerConfig.SERVER_URL}/admin/tenant_cashdrawers/`}
        detail_put_url={`${ServerConfig.SERVER_URL}/admin/tenant_cashdrawers/`}
        add_new_url = {`${ServerConfig.SERVER_URL}/admin/tenant_cashdrawers/`}

        column_names={["id", "name", "edit"]}
        header_names={["id", "name", ""]}

        optional_column_names={["belt_id", "min_threshold_microdollars", "count_diff_notification_trigger_microdollars"]}
        optional_header_names={["belt_id", "min_threshold_microdollars", "count_diff_notification_trigger_microdollars"]}

        editable_fields={editable_fields}
        non_editable_fields={non_editable_fields}
        //ledger_get_url = '/ledger/customer/'
        //show_machine_stats={true}
      />
    </>
  )
}

export default TenantCashdrawers
